var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-badge',{staticClass:"py-1 px-1",attrs:{"color":_vm.getColor(_vm.availability),"bottom":"","dot":"","inline":""}}),_c('span',{domProps:{"textContent":_vm._s(_vm.getAvailability(_vm.availability))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }